import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';

@Component({
  selector: 'app-create-edit-disciplina',
  templateUrl: './create-edit-disciplina.component.html',
  styleUrls: ['./create-edit-disciplina.component.scss'],
})
export class CreateEditDisciplinaComponent implements OnInit {
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public tituloTxt='Crear disciplina'

  constructor(
    public disciplinaSvc: DisciplinaService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateEditDisciplinaComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
    if (data != null) {
      this.isForEdit = true;
      this.tituloTxt='Editar disciplina'
    }
  }

  ngOnInit(): void {
    this.registerForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      nombre: new UntypedFormControl('', Validators.required),
      estado: new UntypedFormControl('', Validators.required),
      minutosIngresosPrevioEntreno: new UntypedFormControl('', [Validators.required, Validators.min(0)]),
    });
    this.registerForm.get('estado')?.setValue(true);
    if (this.isForEdit) {
      this.registerForm.get('id')?.setValue(this.dataInput.id);
      this.registerForm.get('nombre')?.setValue(this.dataInput.nombre);
      this.registerForm.get('estado')?.setValue(this.dataInput.estado);
      this.registerForm.get('minutosIngresosPrevioEntreno')?.setValue(this.dataInput.minutosIngresosPrevioEntreno);
    }
  }

  guardar() {
    console.log('guardar disciplina');
    console.log(this.registerForm.value);
    if (this.isForEdit) {
      //aqui mando a editar
      this.disciplinaSvc
        .editDisciplina(this.registerForm.value)
        .subscribe((res) => {
          console.log('resultado Editar: ', res);
          if (res) {
            this.alertify.success('Disciplina actualizada');
            this.dialogRef.close();
          } else {
            this.alertify.error('La disciplina no se ha podido actualizar');
          }
        });
    } else {
      //aqui mando a crearlo
      this.registerForm
        .get('id')
        ?.setValue('00000000-0000-0000-0000-000000000000');
      this.disciplinaSvc
        .addDisciplina(this.registerForm.value)
        .subscribe((res) => {
          console.log('resultado crearUsuario: ', res);
          if (res) {
            this.alertify.success('Disciplina creada');
            this.dialogRef.close();
          } else {
            this.alertify.error(
              'La disciplina ya existe, valide la información e intentelo de nuevo'
            );
          }
        });
    }
  }
}
